import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { getResourceUuid } from "../../utils/getResourceUuid";
import { IClassroom } from "../types/IClassroom";

export enum FileType {
    CSV = "csv_simple_template",
    AGATE = "csv_agate_export",
}

export enum ImportType {
    ADD = "add",
    REPLACE = "replace",
}

export type IClassroomImportLearnerMutationParameters = {
    classroom: RelationalValue<IClassroom>;
    file: File;
    importType: ImportType;
    fileType: FileType;
};

export type IClassroomImportLearnerMutationResult = IClassroom;

export const classroomImportLearnerMutation: IApiMutationFunction<IClassroomImportLearnerMutationParameters> = ({
    classroom,
    file,
    importType,
    fileType,
}) => {
    const formData = new FormData();

    formData.append("uuid", getResourceUuid(classroom));
    formData.append("file", file);
    formData.append("importType", importType);
    formData.append("fileType", fileType);

    return {
        method: "POST",
        url: "/classrooms/learners_file",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
    };
};

export const useClassroomImportLearnerMutation = createApiMutationHook<
    IClassroomImportLearnerMutationParameters,
    IClassroomImportLearnerMutationResult
>(classroomImportLearnerMutation);
